<template>
  <div>
    <v-container>
      <v-toolbar v-if="favoriteProducts.length > 0" class="primary--text" dense>
        <v-toolbar-title>Your favorite products</v-toolbar-title>
        <v-btn icon>
          <v-icon color="red">favorite</v-icon>
        </v-btn>
      </v-toolbar>

      <div v-if="favoriteProducts.length <= 0" class="text-center">
        <v-card class="mt-5">
          <v-card-text>
           <p>Your favorite products will appear here!</p>
           <v-btn outlined color="primary" @click="goToPath('/')">Check out available products</v-btn>
          </v-card-text>
        </v-card>
      </div>

      <div v-else>
        <v-row>
          <v-col v-for="(item, index) in favoriteProducts" :key="index" cols="12" sm="6" md="4" lg="3" xl="2">
            <v-card @click="goToProduct(item)">
              <div class="pa-2">
                <v-img height="200px" width="auto" :src="item.resizedUrl" contain>
                </v-img>
              </div>
              <v-card-text  style="position: relative;">
                  <p class="font-weight-black">{{item.title | limitChars(35)}}<span v-if="item.title.length > 35">...</span></p>
                  <p class="font-weight-bold mt-1 mb-0">
                    <span class="font-weight-bold">Price: </span>
                    <span class="font-weight-bold button">{{item.price}} ZK</span>
                    <span class="font-weight-light caption">/kg</span>
                  </p>
                  <p class="mt-1 mb-0">
                    <span class="font-weight-bold">Category: </span>
                    {{item.category}}
                  </p>
                  <p class="mt-1 mb-0">
                    <span class="font-weight-bold">Location: </span>
                    {{item.district }},  {{item.province }}
                  </p>
                  <v-btn absolute class="white red--text" text bottom right @click.stop="removeFromFavorites(item)">
                    <v-tooltip bottom color="gray darken-3">
                      <template v-slot:activator="{ on }">
                        <v-icon color="red" dark v-on="on">close</v-icon>
                      </template>
                      <span class="font-weight-medium">Remove product from favorites</span>
                    </v-tooltip>
                  </v-btn>
                </v-card-text>

                 <v-snackbar v-model="snackbar" color="primary white--text" :timeout="time" bottom right>
                  {{ snackbarText }}
                  <template>
                    <v-btn color="white" text @click.stop.prevent="addBackToFavorites(removedProducts[removedProducts.length -1])">
                      UNDO
                    </v-btn>
                    <v-icon color="white" @click.stop.prevent="confirmRemoval(removedProducts[removedProducts.length -1].id)">close</v-icon>
                  </template>
                </v-snackbar>
            </v-card>
          </v-col>
        </v-row>
      </div>

    </v-container>
  </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      snackbar: false,
      time: 7000,
      removedProducts: [],
      snackbarText: 'Removed one product from the favorites'
    }
  },
  computed: {
    ...mapGetters(['favoriteProducts', 'allProducts'])
  },
  filters: {
    limitChars(string, limit) {
      if (!string) return ''
      string = string.toString()
      return string.substring(0, limit)
    }
  },
  methods: {
    removeFromFavorites(product) {
      this.snackbar = true
      // only remove it from the vue store
      store.dispatch('removeFromFavorites_store', product.id)
      this.removedProducts.push(product)

      // after timeout remove it from firebase too
      this.timeout = setTimeout(() => {
        store.dispatch('removeFromFavorites', product.id)
      }, this.time)
    },
    addBackToFavorites(product) {
      this.snackbar = false

      store.dispatch('addBackToFavorites', product)
      // clear the timeout
      clearTimeout(this.timeout)
    },

    confirmRemoval(id) {
      this.snackbar = false
      // remove from firestore
      store.dispatch('removeFromFavorites', id)
      // clear the timeout
      clearTimeout(this.timeout)
    },
    goToProduct(item) {
      if (!store.getters.supplierById(item.supplierId)) {
        const supplier = {
          id: item.supplierId,
          type: item.supplierType
        }
        store.dispatch('fetchSupplierInfo', supplier)
      }
      this.$router.push({
        name: 'Product',
        params: { id: item.id }
      })
    }
  }
}
</script>
